
<div class="split">
    <div class="left">
        <tree-view [selectedFolder]="selectedFolderStore" [rootLevelStore]="folderRoot" (change)="treeEvent($event)" [disableSelection]="true"></tree-view>    
    </div>
    <div translate class="mid">
        GENERIC.SEARCH
        <input name="search" [formControl]="searchController"/>

        <div *ngIf="searchText?.length" class="search">
            <h3>Search Results : {{ searchText }}</h3>
            <button (click)="searchController.setValue(null)">Clear</button>
            <h5>Folders</h5>
            <div *ngFor="let cur of searchFolders">
                <a (click)="jumpTo(['..',cur.id])">{{ cur.name }}</a>
            </div>
            <h5>Files</h5>
            <div *ngFor="let cur of searchFiles">
                <a (click)="jumpTo(['..',cur.folder?.id || 'root'],{files:cur.id})">{{ cur.name }}</a>
            </div>

        </div>
        <file-list *ngIf="!searchText?.length" 
            [selectedFolder]="selectedFolderStore"  
            [selectedFiles]="selectedFilesStore" 
            [files]="displayedFilesStore"
            [disableSelection]="true"
            (change)="fileEvent($event)"></file-list>
    </div>
    <div class="right">


        <h3>Processing</h3>
        <div *ngFor="let cur of processing">
            <a [routerLink]="['..',cur.task.folder?.id || 'root']">{{ cur.task.name }}</a> <small>{{ cur.status }}</small>
        </div>
     
        <h3>Upload</h3>
        <input type="file" multiple (change)="upload($event)"/>


        <h4>Uploads Queued:  {{ uploadsQueued.length }}</h4>
        <h4>Uploads Running:  {{ uploads.length }}</h4>
        <div *ngFor="let cur of uploads">
            {{ cur.dataset.name }} {{ cur.progress | percent }} <a (click)="abort(cur)">X</a>
        </div>
        
        <hr/>
    
        <div *ngIf="selectedFiles.length > 1">
            <div *ngFor="let cur of selectedFiles">
                <h3 translate>{{ cur?.name }}</h3>
                <a vlink="data" [model]="cur">GENERIC.DOWNLOAD</a>
                <button (click)="delFile(cur)">DEL</button>
            </div>
        </div>
        <div *ngIf="selectedFiles.length == 1">
            <div *ngFor="let cur of selectedFiles">
                <div *ngIf="!curAdHoc">
                    <h3 translate >{{ cur?.name }}</h3>
                    <a vlink="data" [model]="cur">GENERIC.DOWNLOAD</a>
                    <button (click)="delFile(cur)">DEL</button>
                    <h5>Adhocs</h5>
                    <div *ngFor="let tt of cur.dataType?._adhocTransforms">
                        <button *ngIf="tt" (click)="curAdHoc = tt">{{tt.name}}</button>
                    </div>
                </div>
                <div *ngIf="curAdHoc">
                    <h3>{{ curAdHoc?.name }} on {{ cur.name }} </h3>
                    <div *ngIf="curAdHoc.needsInput">
                    <div qmap-form [transform]="curAdHoc" (commence)="startAdhoc(cur,curAdHoc,$event)" (cancel)="curAdHoc = null"></div>
                    </div>
                    <div *ngIf="!curAdHoc.needsInput">
                        <button (click)="startAdHoc(cur,curAdHoc)">Start</button>
                    </div>
                </div>
            </div>
        </div>
        
     
    </div>
</div>
